import AppleIcon from '@assets/logos/Social/icons/icon-apple.svg';
import DiscordIcon from '@assets/logos/Social/icons/icon-discord.svg';
import FacebookIcon from '@assets/logos/Social/icons/icon-fb.svg';
import BiometricsIcon from '@assets/logos/Social/icons/icon-fingerprint.svg';
import PasskeyIcon from '@assets/logos/Social/icons/icon-passkey.svg';
import GithubIcon from '@assets/logos/Social/icons/icon-github.svg';
import GitlabIcon from '@assets/logos/Social/icons/icon-gitlab.svg';
import GoogleIcon from '@assets/logos/Social/icons/icon-google.svg';
import SsoIcon from '@assets/logos/Social/icons/icon-key.svg';
import LinkedinIcon from '@assets/logos/Social/icons/icon-linkedin.svg';
import MicrosoftIcon from '@assets/logos/Social/icons/icon-ms.svg';
import { Element } from '@craftjs/core';
import {
	Autorenew,
	Crop54,
	DatasetLinked,
	Dns,
	Error,
	HorizontalRule,
	Input,
	InputOutlined,
	InsertPhoto,
	Landscape,
	Link,
	Notes,
	QrCodeScanner,
	SmartButton,
	TextFields
} from '@mui/icons-material';
import {
	EditorAppleButton,
	EditorBiometricsButton,
	EditorButton,
	EditorCode,
	EditorContainer,
	EditorCustomLoginIdInput,
	EditorDiscordButton,
	EditorDivider,
	EditorEmailInput,
	EditorEntityIdInput,
	EditorErrorMessage,
	EditorFacebookButton,
	EditorFirstNameInput,
	EditorFullNameInput,
	EditorGithubButton,
	EditorGitlabButton,
	EditorGoogleButton,
	EditorImage,
	EditorLastNameInput,
	EditorLink,
	EditorLinkedinButton,
	EditorLoginUrlInput,
	EditorLogo,
	EditorMicrosoftButton,
	EditorPasskeyButton,
	EditorPhone,
	EditorPollingLoader,
	EditorSSOButton,
	EditorTenantDomainInput,
	EditorTenantNameInput,
	EditorText,
	EditorNewPassword,
	EditorPassword
} from 'pages/PageEditor/editorComponents';
import { EditorCertificateTextarea } from 'pages/PageEditor/editorComponents/editorTextareas/customTextareas/EditorCertificateTextarea';
import {
	EditorTOTPImage,
	EditorTOTPLink
} from 'pages/PageEditor/editorComponents/editorTOTP';
import React from 'react';

export default [
	{
		label: 'screenEditor.leftBar.components.container',
		editorComponent: (
			<Element is={EditorContainer as React.ElementType} canvas />
		),
		icon: <Crop54 />
	},
	{
		label: 'screenEditor.leftBar.components.buttons',
		children: [
			{
				label: 'screenEditor.leftBar.components.buttons.button',
				editorComponent: <EditorButton />,
				icon: <SmartButton />
			},
			{
				label: 'screenEditor.leftBar.components.buttons.google',
				editorComponent: <EditorGoogleButton />,
				icon: <img src={GoogleIcon} alt="google" />,
				tags: ['socials', 'alphabet']
			},
			{
				label: 'screenEditor.leftBar.components.buttons.facebook',
				editorComponent: <EditorFacebookButton />,
				icon: <img src={FacebookIcon} alt="facebook" />,
				tags: ['socials', 'meta']
			},
			{
				label: 'screenEditor.leftBar.components.buttons.microsoft',
				editorComponent: <EditorMicrosoftButton />,
				icon: <img src={MicrosoftIcon} alt="microsoft" />,
				tags: ['socials']
			},
			{
				label: 'screenEditor.leftBar.components.buttons.linkedin',
				editorComponent: <EditorLinkedinButton />,
				icon: <img src={LinkedinIcon} alt="linkedin" />,
				tags: ['socials']
			},
			{
				label: 'screenEditor.leftBar.components.buttons.github',
				editorComponent: <EditorGithubButton />,
				icon: <img src={GithubIcon} alt="github" />,
				tags: ['socials']
			},
			{
				label: 'screenEditor.leftBar.components.buttons.apple',
				editorComponent: <EditorAppleButton />,
				icon: <img src={AppleIcon} alt="apple" />,
				tags: ['socials']
			},
			{
				label: 'screenEditor.leftBar.components.buttons.discord',
				editorComponent: <EditorDiscordButton />,
				icon: <img src={DiscordIcon} alt="discord" />,
				tags: ['socials']
			},
			{
				label: 'screenEditor.leftBar.components.buttons.gitlab',
				editorComponent: <EditorGitlabButton />,
				icon: <img src={GitlabIcon} alt="gitlab" />,
				tags: ['socials']
			},
			{
				label: 'screenEditor.leftBar.components.buttons.biometrics',
				editorComponent: <EditorBiometricsButton />,
				icon: <img src={BiometricsIcon} alt="biometrics" />,
				tags: ['webauthn']
			},
			{
				label: 'screenEditor.leftBar.components.buttons.passkey',
				editorComponent: <EditorPasskeyButton />,
				icon: <img src={PasskeyIcon} alt="passkey" />,
				tags: ['webauthn']
			},
			{
				label: 'screenEditor.leftBar.components.buttons.sso',
				editorComponent: <EditorSSOButton />,
				icon: <img src={SsoIcon} alt="sso" />,
				tags: ['saml', 'single sign on']
			}
		]
	},
	{
		label: 'screenEditor.leftBar.components.inputs',
		children: [
			{
				label: 'screenEditor.leftBar.components.inputs.email',
				editorComponent: <EditorEmailInput />,
				icon: <Input />
			},
			{
				label: 'screenEditor.leftBar.components.inputs.phone',
				editorComponent: <EditorPhone />,
				icon: <Input />
			},
			{
				label: 'screenEditor.leftBar.components.inputs.code',
				editorComponent: <EditorCode />,
				icon: <Input />
			},
			{
				label: 'screenEditor.leftBar.components.inputs.firstName',
				editorComponent: <EditorFirstNameInput />,
				icon: <Input />
			},
			{
				label: 'screenEditor.leftBar.components.inputs.lastName',
				editorComponent: <EditorLastNameInput />,
				icon: <Input />
			},
			{
				label: 'screenEditor.leftBar.components.inputs.fullName',
				editorComponent: <EditorFullNameInput />,
				icon: <Input />
			},
			{
				label: 'screenEditor.leftBar.components.inputs.customLoginId',
				editorComponent: <EditorCustomLoginIdInput />,
				icon: <Input />
			},
			{
				label: 'screenEditor.leftBar.components.inputs.tenantName',
				editorComponent: <EditorTenantNameInput />,
				icon: <Input />
			}
		]
	},
	{
		label: 'screenEditor.leftBar.components.text',
		children: [
			{
				label: 'screenEditor.leftBar.components.text.text',
				editorComponent: <EditorText />,
				icon: <TextFields />
			},
			{
				label: 'screenEditor.leftBar.components.text.link',
				editorComponent: <EditorLink />,
				// eslint-disable-next-line jsx-a11y/anchor-is-valid
				icon: <Link />
			},
			{
				label: 'screenEditor.leftBar.components.text.divider',
				editorComponent: <EditorDivider />,
				icon: <HorizontalRule />
			},
			{
				label: 'screenEditor.leftBar.components.text.errorMessage',
				editorComponent: <EditorErrorMessage />,
				icon: <Error />
			}
		]
	},

	{
		label: 'screenEditor.leftBar.components.images',
		children: [
			{
				label: 'screenEditor.leftBar.components.images.image',
				editorComponent: <EditorImage />,
				icon: <InsertPhoto />
			},
			{
				label: 'screenEditor.leftBar.components.images.logo',
				editorComponent: (
					<EditorLogo
						height={100} // this is the default logo height
					/>
				),
				icon: <Landscape />
			}
		]
	},
	{
		label: 'screenEditor.leftBar.components.magicEnchantedLink',
		children: [
			{
				label: 'screenEditor.leftBar.components.magicEnchantedLink.polling',
				editorComponent: <EditorPollingLoader />,
				icon: <Autorenew />
			}
		]
	},
	{
		label: 'screenEditor.leftBar.components.totp',
		children: [
			{
				label: 'screenEditor.leftBar.components.totp.image',
				editorComponent: <EditorTOTPImage />,
				icon: <QrCodeScanner />
			},
			{
				label: 'screenEditor.leftBar.components.totp.url',
				editorComponent: <EditorTOTPLink />,
				icon: <DatasetLinked />
			}
		]
	},
	{
		label: 'screenEditor.leftBar.components.passwords',
		children: [
			{
				label: 'screenEditor.leftBar.components.passwords.signin',
				editorComponent: <EditorPassword />,
				icon: <InputOutlined />
			},
			{
				label: 'screenEditor.leftBar.components.passwords.newPassword',
				editorComponent: <EditorNewPassword />,
				icon: <InputOutlined />
			}
		]
	},
	{
		label: 'screenEditor.leftBar.components.sso',
		children: [
			{
				label: 'screenEditor.leftBar.components.sso.tenantDomain',
				editorComponent: <EditorTenantDomainInput />,
				icon: <Dns />
			},
			{
				label: 'screenEditor.leftBar.components.sso.entityId',
				editorComponent: <EditorEntityIdInput />,
				icon: <Input />
			},
			{
				label: 'screenEditor.leftBar.components.sso.loginUrl',
				editorComponent: <EditorLoginUrlInput />,
				icon: <Input />
			},
			{
				label: 'screenEditor.leftBar.components.sso.certificate',
				editorComponent: <EditorCertificateTextarea />,
				icon: <Notes />
			}
		]
	}
];
